import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { GetResourcesList } from "../../api/resource-function";
import { Container,Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Metatag from '../../hooks/Metatag'

export default function Resources() {
  const [toggler, setToggler] = useState(true);
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    // add class for home header and remove inner class
    $(".fixed-top").addClass("bg-header");

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();


  }, []);

  const [getResourceList, setResourceList] = useState(null);

   // success function when the list is retrived
   const OnGetResourceSuccess = (p_response) => {
    
    // set the list for looping
    setResourceList(p_response);
}

  useEffect(()=>{
    let _obj = new Object();
    _obj.resource_status = 1;
  
    // call the function to get the resource 
    GetResourcesList(_obj, OnGetResourceSuccess,navigate); 

  },[])
  

 
  return (
    <>
      <Header main_className="bg-header"></Header>

      {/* Metatag  */}
      <Metatag title='Online Resources for Disease Modelling | Website links for Disease Database'
                        keywords='Online Resources for Disease Modelling, Website links for Disease Database, Disease Modelling Websites, Disease Database Online, Disease Modelling Online' 
                        description='Online Resources and Website links for Disease Modelling and Disease Database'
                        />

      <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('./images/bg-resources.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
        <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
        <div className="masthead d-flex align-items-center w-100">
          <Container className="px-4 px-md-5">
            <h1 className="mb-0 fw-bold text-white text-uppercase pb-xl-5 py-4">Resources</h1>
          </Container>
        </div>
      </Container>

      {
        getResourceList != null ?
          getResourceList.length > 0 ?
            <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
              <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 992: 2, 1280: 2 }}>
                <Masonry gutter="1.5rem" className="resources">
                  {
                    getResourceList.map((val_resource)=>{
                      return(
                            <>
                              <div>
                                <h2 class="fw-bold text-danger">{val_resource.resource_name}</h2>
                                <div class="list overflow-hidden"> 
                                    <div dangerouslySetInnerHTML={{ __html : val_resource.resource_desc }}></div> 
                                </div> 
                              </div> 
                            </>
                      )
                    })
                  }

                </Masonry>
              </ResponsiveMasonry>
            </Container >
          :
            <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
            <Row>
              <span className="text-center"><b>No records found</b></span>
            </Row>
          </Container>
        :
        <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
        <Row>
          <span className="text-center">Loading...</span>
        </Row>
      </Container>
      }


      {/* Breadcrumb */}
      <Container fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto" >
        <Breadcrumb>
          <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
          <Breadcrumb.Item active>Resources</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
      {/* Breadcrumb */}
    </>
  );
}